import gsap from 'gsap'
import BaseComponent from './_BaseComponent'

/* TileSelector
---------------------------------------------------------------------------------------------------- */

export default class TileSelector extends BaseComponent {

    constructor($el, namespace) {
        super('TileSelector', $el, namespace)

        this.on()
    }


    bindProperties() {
        this.leaveTimer = null

        this.onResize()
        this.onChange()
    }


    bindHandlers() {
        this.submitHandler = e => this.onSubmit(e)

        this.enterHandler = e => this.onEnter(e)
        this.leaveHandler = e => this.onLeave(e)
        this.resizeHandler = () => this.onResize()
        this.changeHandler = () => this.onChange()
    }


    bindEvents() {
        const { $input, $tile } = this.$refs

        this.addListeners(
            [this.$el, 'submit', this.submitHandler],
            [$input, 'change', this.changeHandler],

            [$tile, 'mouseenter focusin', this.enterHandler],
            [$tile, 'mouseleave focusout', this.leaveHandler],

            [document, 'layoutChange', this.resizeHandler],
        )
    }



    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        if (!APP.Layout.isDesktop) return

        const { $container, $tile, $focus } = this.$refs

        const { offsetWidth, offsetHeight } = $container[0]
        const { offsetWidth: tW, offsetHeight: tH } = $tile[0]


        this.center = {
            x: offsetWidth / 2,
            y: offsetHeight / 2,
        }


        gsap.set($focus, {
            '--tileWidth'  : `${tW}px`,
            '--tileHeight' : `${tH}px`,
        })
    }


    onSubmit(e) {
        e.preventDefault()

        this.interceptQuery()
    }


    onChange() {
        const { $input, $submitBtn, $count } = this.$refs

        const amount = $input.filter(inp => inp.checked).length
        const hasCheckedFilter = amount > 0

        $count.text(amount)
        $submitBtn.toggleClass('has-selected-filters', hasCheckedFilter)
    }



    onEnter(e) {
        if (!APP.Layout.isDesktop) return

        clearTimeout(this.leaveTimer)

        const { $focus } = this.$refs

        $focus.addClass('is-hovered')

        this.pointerFocus(e.currentTarget)
    }


    onLeave(e) {
        if (!APP.Layout.isDesktop) return

        const { $focus } = this.$refs

        this.leaveTimer = setTimeout(() => {
            $focus.removeClass('is-hovered')
        }, 200)
    }

    /* Actions
    --------------------------------------------------------- */

    interceptQuery() {
        const $form = this.$el

        const selfFormData = new FormData($form[0])
        const params = {}
        const url    = $form.attr('data-action')
        let query    = ''

        const data = Array.from(selfFormData.entries()).reduce((a, [k, v]) => {
            if (!(k in a)) {
                a[k] = []
            }

            a[k].push(v)

            return a
        }, params)


        Object.entries(data).forEach(([k, v]) => {
            if (!query.length) {
                query += '?'
            }

            query += `${k}=${v.join(',')}`
        })

        window.location.href = url + query
    }


    pointerFocus($el) {
        if (!APP.Layout.isDesktop) return

        const { $focus } = this.$refs
        const { offsetLeft, offsetTop } = $el

        const transX = offsetLeft - this.center.x
        const transY = offsetTop - this.center.y

        gsap.to($focus, {
            x: transX,
            y: transY,
            overwrite: true,
            duration: 0.4,
            force3D: true,
            ease: 'power3.out',
        })
    }


    /* Values
    --------------------------------------------------------- */



}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */
